module.exports = __webpack_public_path__ + "img/lk-letter.30270e3c.svg";